<template>
	<div class="home_box">
		<div class="swiper-container maxcontainer" style="width: 100vw;height: 100vh;overflow: hidden;">
			<div class="swiper-wrapper">
				<!-- 第一屏 -->
				<div class="swiper-slide swiper-no-swiping" style="width: 100vw;height: 100vh;">
					<Banner1></Banner1>
				</div>
				<!-- 第二屏 -->
				<!-- <div class="swiper-slide swiper-no-swiping" style="  width: 100vw;height: 100vh;">
					<div class="two">
						<div class="title_box">AI办公解决方案</div>
						<div class="pt1">降本、提效、减负</div>
						<div class="pt2">将繁琐的⽇常办公流程交给AI处理，释放员⼯潜⼒，聚焦核⼼业务</div>
						<div class="two-yi">
							<div class="two-yi-yi" v-for="(item,index) in oneData" :key="index"
								@click="activeIndex = activeIndex === index ? -1 : index"
								:class="{ active: activeIndex === index }">
								<img :src="activeIndex === index ? item.imgActive : item.img" />
								<div class="two-yi-yi-han1">{{item.name}}</div>
								<div class="two-yi-yi-han2">{{item.text}}</div>
							</div>
						</div>
					</div>
				</div> -->
				<!-- 第三屏 -->
				<!-- <div class="swiper-slide swiper-no-swiping" style="  width: 100vw;height: 100vh;">
					<div class="two san">
						<div class="title_box">AI应用定制开发</div>
						<div class="pt1">专属AI⼯具、系统AI化</div>
						<div class="pt2">根据企业独特业务场景，提供原⽣级别的⼩程序与私有化系统AI改造</div>
						<div class="two-san">
							<div class="two-san-yi" v-for="(item,index) in twoData" :key="index">
								<div class="two-san-yi-zuo">
									<img src="../../static/images/ai/zsgjkf.png" />
								</div>
								<div class="two-san-yi-you">
									<div class="two-san-yi-you-yi">专属工具开发</div>
									<div class="two-san-yi-you-er">如行业知识库问答系统、智能营销文案生成工具、定制化数据处理软件等</div>
								</div>
							</div>
						</div>
					</div>
				</div> -->
				<!-- 第四屏 -->
				<!-- <div class="swiper-slide swiper-no-swiping" style="  width: 100vw;height: 100vh;">
					<div class="si">
						<div class="si-yi">
							<div class="si-yi-yi">为什么选择我们？</div>
							<div class="si-yi-er">技术抹平槛,打造中企业的数字化外脑
							</div>
							<div class="si-yi-san">
								<div class="si-yi-san-yi" v-for="(item,index) in sanData" :key="index">
									<div class="si-yi-san-yi-yi">
										<div class="qiye">
											<img :src="item.img" />
										</div>
										<div class="qiye-you">
											<span>{{item.name}}</span>
											<span>{{item.text}}</span>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div> -->
				<!-- <div class="swiper-slide swiper-no-swiping" style="  width: 100vw;height: 100vh;">
					<div class="wu">
						<div class="wu-yi">企业专属AI工具/系统</div>
						<div class="wu-er">
							<div class="wu-er-yi" v-for="(item,index) in siData" :key="index">
								<div class="wu-er-bt">{{item.title}}</div>
								<div class="wu-er-yi-yi" v-for="(ite,ind) in item.listData" :key="ind">
									<div class="wu-er-yi-yi-tu">
										<img :src="ite.img" />
									</div>
									<div class="wu-er-yi-yi-han">{{ite.name}}</div>
								</div>
							</div>
						</div>
					</div>
				</div> -->
				<!-- <div class="swiper-slide swiper-no-swiping" style="  width: 100vw;height: 100vh;">
					<div style="height: 100%" data-scroll="true">
						<div class="liu">
							<div class="liu-yi"></div>
						</div>
						<Footer></Footer>
					</div>
				</div> -->
			</div>
		</div>
		<div class="two">
			<div class="title_box">AI办公解决方案</div>
			<div class="pt1">降本、提效、减负</div>
			<div class="pt2">将繁琐的⽇常办公流程交给AI处理，释放员⼯潜⼒，聚焦核⼼业务</div>
			<div class="two-yi">
				<div class="two-yi-yi" v-for="(item,index) in oneData" :key="index" @click="activeIndex = index"
					@mouseenter="hoverIndex = index" @mouseleave="hoverIndex = -1"
					:class="{ active: !hoverIndex && activeIndex === index }">
					<!-- 图片：hover 优先，hover 时自动隐藏 active -->
					<img :src="(hoverIndex === index || (!hoverIndex && activeIndex === index)) 
			           ? item.imgActive 
			           : item.img" />

					<div class="two-yi-yi-han1">{{item.name}}</div>
					<div class="two-yi-yi-han2">{{item.text}}</div>
				</div>
			</div>
		</div>
		<div class="two san">
			<div class="title_box">AI应用定制开发</div>
			<div class="pt1">专属AI⼯具、系统AI化</div>
			<div class="pt2">根据企业独特业务场景，提供原⽣级别的⼩程序与私有化系统AI改造</div>
			<div class="two-san">
				<div class="two-san-yi" v-for="(item,index) in twoData" :key="index">
					<div class="two-san-yi-zuo">
						<img :src="item.img" />
					</div>
					<div class="two-san-yi-you">
						<div class="two-san-yi-you-yi">{{item.name}}</div>
						<div class="two-san-yi-you-er">{{item.text}}</div>
					</div>
				</div>
			</div>
		</div>
		<div class="si">
			<div class="si-yi">
				<div class="si-yi-yi">为什么选择我们？</div>
				<div class="si-yi-er">技术抹平槛,打造中企业的数字化外脑
				</div>
				<div class="si-yi-san">
					<div class="si-yi-san-yi" v-for="(item,index) in sanData" :key="index">
						<div class="si-yi-san-yi-yi">
							<div class="qiye">
								<img :src="item.img" />
							</div>
							<div class="qiye-you">
								<span>{{item.name}}</span>
								<span>{{item.text}}</span>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="wu">
			<div class="wu-yi">企业专属AI工具/系统</div>
			<div class="wu-er">
				<div class="wu-er-yi" v-for="(item,index) in siData" :key="index">
					<div class="wu-er-bt">{{item.title}}</div>
					<div class="wu-er-yi-yi" v-for="(ite,ind) in item.listData" :key="ind">
						<div class="wu-er-yi-yi-tu">
							<img :src="ite.img" />
						</div>
						<div class="wu-er-yi-yi-han">{{ite.name}}</div>
					</div>
				</div>
			</div>
		</div>
		<div class="liu">
			<div class="liu-yi">
				<div class="liu-yi-bt1">准备好开启企业的 AI 转型了吗？</div>
				<div class="liu-yi-bt2">今天预约，即可获得包含业务诊断、流程梳理、工具选型在内的《中小企业AI化深度建议书》一份</div>
				<div class="liu-yi-an">
					<div class="liu-yi-an1">
						<img src="../../static/images/ai/mf.png"/>
						<span>免费方案评估</span>
					</div>
					<div class="liu-yi-an2">
						<img src="../../static/images/ai/ydy.png"/>
						<span>一对一需求梳理</span>
					</div>
				</div>
			</div>
		</div>
		<Footer></Footer>
	</div>
</template>

<script>
	import Banner1 from "@/components/banner1.vue";
	import Footer from "@/components/footer.vue";
	import {
		listProduct
	} from "@/api/product";
	import {
		listExample
	} from "@/api/presentation";
	import {
		listNews
	} from "@/api/news";
	export default {
		components: {
			Footer,
			Banner1
		},
		computed: {
			currentPage: {
				get() {
					return this.$store.state.currentPage
				},
				set(value) {
					this.$store.commit('putcurrentPage', value)
				}
			}
		},
		data() {
			return {
				// 第几屏
				HomeSwiperId: 0,
				swiper: '',
				// 第二屏参数
				numerical: {
					fuwu: 0,
					huigou: 0,
					haoping: 0,
					hangye: 0,
				},
				pages2: '',
				// 第三屏参数
				serviceSwiperId: 0,
				serviceSize: '100% 100%',
				serviceList: [],
				oneData: [{
						name: '智能文档处理',
						text: '自动识别、提取、整理合同、报表等文件关键信息，减少80%手动录入工作',
						img: require('@/static/images/ai/wendang.png'),
						imgActive: require('@/static/images/ai/wendang1.png')
					},
					{
						name: '高效协同工具',
						text: 'AI辅助会议纪要生成、任务分配与跟进，跨部门协作效率提升50%',
						img: require('@/static/images/ai/gx.png'),
						imgActive: require('@/static/images/ai/gx1.png')
					},
					{
						name: '智能客服集成',
						text: '7x24小时响应客户咨询，降低人工客服成本提升服务响应速度',
						img: require('@/static/images/ai/kf.png'),
						imgActive: require('@/static/images/ai/kf1.png')
					},
					{
						name: '数据智能分析',
						text: '自动整合多平台数据，生成可视化报表，为决策提供数据支撑',
						img: require('@/static/images/ai/fx.png'),
						imgActive: require('@/static/images/ai/sjznfx1.png')
					}
				],
				// 记录当前选中的索引，默认 -1 = 都不选中
				activeIndex: -1,
				hoverIndex: -1,
				twoData: [{
					name: '专属工具开发',
					text: '如行业知识库问答系统、智能营销文案生成工具、定制化数据处理软件等',
					img: require('@/static/images/ai/zsgjkf.png'),
				}, {
					name: '小程序/系统AI化升级',
					text: '为现有小程序、管理系统植入AI能力(如智能推荐、语音交互、预测分析)',
					img: require('@/static/images/ai/xcx.png'),
				}, {
					name: '全场景适配',
					text: '覆盖电商、制造、服务财税等多行业，满足个性化业务场景需求',
					img: require('@/static/images/ai/qcjsp.png'),
				}, {
					name: '持续迭代优化',
					text: '上线后根据使用反馈，提供免费迭代服务，保障工具适配业务增长',
					img: require('@/static/images/ai/dd.png'),
				}],
				sanData: [{
					name: '懂中小企业',
					text: '不搞虚⽆缥缈的⼤⼚架构，我们深知中⼩企业痛点，提供落地即⽤、⽴竿⻅影的实战⽅案。',
					img: require('@/static/images/ai/qiye.png'),
				}, {
					name: '双赛道能力',
					text: '兼具标准化办公提效工具与深度业务应用定制的全栈能力，一站式解决所有需求。',
					img: require('@/static/images/ai/ssd.png'),
				}, {
					name: '快速交付',
					text: '基于成熟底座模块化搭建，通常在7-15天即可完成系统测试并上线投入使用。',
					img: require('@/static/images/ai/ksjf.png'),
				}, {
					name: '性价比高',
					text: '绝无隐形消费，纯按企业真实需求量身付费，彻底打破行业高定制门槛。',
					img: require('@/static/images/ai/xbjg.png')
				}],
				siData: [{
						title: '办公自动化',
						listData: [{
								img: require('@/static/images/ai1/yj.png'),
								name: '￮邮件管理'
							},
							{
								img: require('@/static/images/ai1/rl.png'),
								name: '￮日历与日程'
							},
							{
								img: require('@/static/images/ai1/wd.png'),
								name: '￮文档处理'
							},
							{
								img: require('@/static/images/ai1/crm.png'),
								name: '￮CRM与客户管理'
							},
							{
								img: require('@/static/images/ai1/hy.png'),
								name: '￮会议与协作'
							},
							{
								img: require('@/static/images/ai1/bj.png'),
								name: '￮笔记与知识库'
							}
						]
					},
					{
						title: '系统工具',
						listData: [{
								img: require('@/static/images/ai1/wj.png'),
								name: '￮文件管理'
							},
							{
								img: require('@/static/images/ai1/xtjk.png'),
								name: '￮系统监控'
							},
							{
								img: require('@/static/images/ai1/wlgj.png'),
								name: '￮网络工具'
							},
							{
								img: require('@/static/images/ai1/zdhgj.png'),
								name: '￮自动化工具'
							},
							{
								img: require('@/static/images/ai1/aqgj.png'),
								name: '￮安全工具'
							},
							{
								img: require('@/static/images/ai1/mtcl.png'),
								name: '￮媒体处理'
							}
						]
					}, {
						title: '其他',
						listData: [{
								img: require('@/static/images/ai1/aiss.png'),
								name: '￮AI与搜索'
							},
							{
								img: require('@/static/images/ai1/sjmt.png'),
								name: '￮社交媒体'
							},
							{
								img: require('@/static/images/ai1/jrjy.png'),
								name: '￮金融与交易'
							},
							{
								img: require('@/static/images/ai1/jksh.png'),
								name: '￮健康与生活'
							},
							{
								img: require('@/static/images/ai1/ylyx.png'),
								name: '￮娱乐与游戏'
							},
							{
								img: require('@/static/images/ai1/qt.png'),
								name: '￮其他'
							}
						]
					}
				]
			}
		},
		mounted() {
			// this.getHomeSwiper()
			this.getData()
		},
		watch: {},
		methods: {
			// 获取初始数据
			getData() {
				listProduct({}).then(response => {
					this.productList = response.rows;
				});
			},
			// 首页整屏滚动初始化
			getHomeSwiper() {
				var _this = this
				// this.$refs.scrollbar.wrap.onscroll = (e) => {
				//   _this.scrollTop = e.target.scrollTop
				//   if (e.target.scrollTop == 0) {
				//     _this.swiper.slidePrev()
				//     _this.swiper.enableMousewheelControl()
				//   }
				// }

				this.swiper = new Swiper('.maxcontainer', {
					initialSlide: _this.currentPage,
					direction: 'vertical',
					loop: false, //不循环
					spaceBetween: 0, // swiper-slide 间的距离为0
					autoplay: false, // 不自动切换
					speed: 700, // 每次切换时长
					// scrollbar: '.swiper-scrollbar', // 滚动条
					mousewheelControl: true, // 开启鼠标切换
					noSwiping: true, // 开启不允许切换
					onSlideChangeEnd: function(swiper) {
						_this.HomeSwiperId = swiper.activeIndex
					}
				});
			},
		}
	}
</script>


<style lang="scss" scoped>
	@keyframes moreframe {
		0% {
			opacity: 0;
		}

		100% {
			opacity: 1;
		}
	}

	.home_box {
		text-align: center;

		.banner_box {
			width: 100vw;
			height: 100vh;
		}

		.title_box {
			display: inline-block;
			position: relative;
			font-size: 0.153rem;
			font-family: MicrosoftYaHei;
			color: #ffffff;
			opacity: 1;
			margin: 0.225rem 0 0.1383rem;
		}

		.title_box::before {
			content: "";
			position: absolute;
			left: -0.4083rem;
			top: 58%;
			transform: translateY(-50%);
			width: 0.2083rem;
			height: 0.2188rem;
			background-image: url("../../static/images/icon/title_left.png");
			background-size: 100% 100%;
		}

		.title_box::after {
			content: "";
			position: absolute;
			right: -0.4083rem;
			top: 58%;
			transform: translateY(-50%);
			width: 0.2083rem;
			height: 0.2188rem;
			background-image: url("../../static/images/icon/title_right.png");
			background-size: 100% 100%;
		}

		.two {
			width: 100%;
			height: 100%;
			background-image: url('../../static/images/ai/bg.png');
			background-repeat: no-repeat;
			background-size: 100% 100%;

			.title_box {
				margin-top: 0.58rem;
				font-family: Source Han Sans CN, Source Han Sans CN;
				font-weight: bold;
				font-size: 0.31rem;
				color: #FFFFFF;
			}

			.pt1 {
				font-family: Source Han Sans CN, Source Han Sans CN;
				font-weight: 400;
				font-weight: 400;
				font-size: 0.15rem;
				color: #FFFFFF;
				display: flex;
				justify-content: center;
				margin-top: 0.24rem;
			}

			.pt2 {
				font-family: Source Han Sans CN, Source Han Sans CN;
				font-weight: 400;
				font-size: 0.16rem;
				color: #FFFFFF;
				display: flex;
				justify-content: center;
				margin-top: 8px;
			}

			.two-yi {
				display: flex;
				// align-items: center;
				justify-content: space-between;
				width: 88%;
				margin: auto;
				margin-top: 0.68rem;
				padding-bottom: 0.78rem;

				.two-yi-yi {
					width: 1.89rem;
					height: 2.35rem;
					background: #FFFFFF;
					border-radius: 0.14rem;
					display: flex;
					flex-direction: column;
					align-items: center;

					img {
						width: 0.52rem;
						height: 0.52rem;
						margin-top: 0.26rem;
					}

					.two-yi-yi-han1 {
						font-family: Source Han Sans CN, Source Han Sans CN;
						font-weight: bold;
						font-size: 0.17rem;
						color: #333333;
						margin-top: 0.14rem;
					}

					.two-yi-yi-han2 {
						font-family: Source Han Sans CN, Source Han Sans CN;
						font-weight: 400;
						font-size: 0.14rem;
						color: #666666;
						margin-top: 0.10rem;
						padding: 0px 19px;
					}
				}

				.two-yi-yi:hover,
				.two-yi-yi.active {
					background: #166AFC;
					border: 2px solid #FFFFFF;
				}

				/* 文字变白 */
				.two-yi-yi:hover .two-yi-yi-han1,
				.two-yi-yi:hover .two-yi-yi-han2,
				.two-yi-yi.active .two-yi-yi-han1,
				.two-yi-yi.active .two-yi-yi-han2 {
					color: #FFFFFF !important;
				}
			}

			.two-san {
				display: flex;
				align-items: center;
				justify-content: space-around;
				flex-wrap: wrap;
				margin-top: 0.31rem;
				padding: 0px 1.88rem;
				padding-bottom: 0.6rem;

				.two-san-yi {
					width: 3.03rem;
					height: 1.44rem;
					background: #FFFFFF;

					border-radius: 0.11rem;
					display: flex;
					margin-bottom: 0.19rem;
					align-items: flex-start;

					&:hover {
						box-shadow: 0rem 0rem 0.1rem 0.01rem #FF6F00;
					}

					.two-san-yi-zuo {
						margin-top: 0.23rem;
						margin-left: 0.21rem;

						img {
							width: 0.27rem;
							height: 0.27rem;
						}
					}

					.two-san-yi-you {
						margin-left: 0.16rem;
						display: flex;
						flex-direction: column;
						margin-top: 0.24rem;
						margin-right: 0.21rem;
						width: calc(100% - 0.8rem);
						/* 占满剩余宽度，关键！*/
						align-items: flex-start;
						/* 强制所有内容左对齐 */

						.two-san-yi-you-yi {
							font-family: Source Han Sans CN, Source Han Sans CN;
							font-weight: bold;
							font-size: 0.16rem;
							color: #2F2F2F;
							text-align: left;
						}

						.two-san-yi-you-er {
							font-family: Source Han Sans CN, Source Han Sans CN;
							font-weight: 400;
							font-size: 0.14rem;
							color: #999999;
							margin-top: 10px;

							/* ✅ 修复换行对齐：强制满宽 + 左对齐 */
							width: 100%;
							text-align: left;
							white-space: normal;
						}
					}
				}
			}

		}

		.san {
			background-image: url('../../static/images/ai/bg1.png');
		}

		.si {
			width: 100%;
			height: 100%;
			background-image: url('../../static/images/ai/bg2.png');
			background-repeat: no-repeat;
			background-size: 100% 100%;

			.si-yi {
				width: 80%;
				display: flex;
				align-items: center;
				margin: auto;
				padding: 0.52rem 0px;

				.si-yi-yi {
					font-family: Microsoft YaHei, Microsoft YaHei;
					font-weight: bold;
					font-size: 0.42rem;
					color: #000000;
					writing-mode: vertical-rl;
					text-orientation: upright;
					letter-spacing: 0.1rem;
					/* 可选：增加字间距更好看 */
				}

				.si-yi-er {
					font-family: Source Han Sans CN, Source Han Sans CN;
					font-weight: 400;
					font-size: 0.16rem;
					color: #333333;
					writing-mode: vertical-rl;
					text-orientation: upright;
					letter-spacing: 0.05rem;
					margin-left: 0.1rem;
				}

				.si-yi-san {
					display: flex;
					flex-direction: column;
					margin-left: 0.63rem;

					.si-yi-san-yi {
						width: 6.57rem;
						// height: 1.03rem;
						background: #E4EEFF;
						box-shadow: 0.01rem 0.02rem 0.03rem 0.01rem rgba(0, 0, 0, 0.16);
						border-radius: 0.16rem 0.16rem 0.16rem 0.16rem;
						border: 0.02rem solid #FFFFFF;
						margin-bottom: 0.16rem;

						.si-yi-san-yi-yi {
							display: flex;
							align-items: center;
							// justify-content: space-between;
							padding: 0.1rem 0.26rem;

							.qiye {
								img {
									width: 0.61rem;
									height: 0.61rem;
									border-radius: 0.13rem 0.13rem 0.13rem 0.13rem;
								}
							}

							.qiye-you {
								display: flex;
								flex-direction: column;
								margin-left: 0.23rem;
								align-items: flex-start;

								span:nth-child(1) {
									font-family: Source Han Sans CN, Source Han Sans CN;
									font-weight: bold;
									font-size: 0.21rem;
									color: #000000;
									margin-bottom: 0.1rem;
									text-align: left;
								}

								span:nth-child(2) {
									font-family: Source Han Sans CN, Source Han Sans CN;
									font-weight: 400;
									font-size: 0.15rem;
									color: #666666;
									text-align: left !important;
									white-space: normal;
									width: 100%;
									/* 占满父级宽度，保证换行对齐 */
								}
							}
						}
					}
				}
			}

		}

		.wu {
			width: 100%;
			height: 100%;
			background-image: url('../../static/images/ai/bg3.png');
			background-repeat: no-repeat;
			background-size: 100% 100%;

			.wu-yi {
				font-family: Microsoft YaHei, Microsoft YaHei;
				font-weight: bold;
				font-size: 0.36rem;
				color: #021344;
				text-align: center;
				padding-top: 0.78rem;
			}

			.wu-er {
				display: flex;
				align-items: center;
				padding: 0.5rem 1.09rem;
				justify-content: space-around;

				.wu-er-yi {
					width: 2.31rem;
					// height: 3.08rem;
					background: linear-gradient(180deg, #EBF2FE 0%, #FFFFFF 100%);
					box-shadow: 0.01rem 0.02rem 0.03rem 0.01rem rgba(0, 0, 0, 0.16);
					border-radius: 0.4rem 0.4rem 0.4rem 0.4rem;
					border: 0.02rem solid #FFFFFF;
					display: flex;
					flex-direction: column;

					.wu-er-bt {
						font-family: Source Han Sans CN, Source Han Sans CN;
						font-weight: bold;
						font-size: 0.21rem;
						color: #000000;
						text-align: center;
						margin-top: 0.21rem;
						margin-bottom: 0.23rem;
					}

					.wu-er-yi-yi {
						display: flex;
						align-items: center;
						padding-left: 0.36rem;
						padding-bottom: 0.21rem;

						.wu-er-yi-yi-tu {
							margin-right: 0.16rem;
							width: 0.17rem;
							height: 0.17rem;
						}

						.wu-er-yi-yi-han {
							font-family: Source Han Sans CN, Source Han Sans CN;
							font-weight: 400;
							font-size: 0.16rem;
							color: #021344;
						}
					}
				}
			}
		}

		.liu {
			width: 100%;
			height: 2.74rem;
			background: #0F172A;
			display: flex;
			align-items: center;
			justify-content: center;

			.liu-yi {
				width: 6.45rem;
				height: 1.78rem;
				background-image: url('../../static/images/ai/bg4.png');
				background-repeat: no-repeat;
				background-size: 100% 100%;
				display: flex;
				flex-direction: column;
				.liu-yi-bt1 {
					font-family: Microsoft YaHei, Microsoft YaHei;
					font-weight: bold;
					font-size: 0.26rem;
					color: #FFFFFF;
					text-align: center;
					margin-top: 0.23rem;
				}
				.liu-yi-bt2 {
					font-family: Source Han Sans CN, Source Han Sans CN;
					font-weight: 400;
					font-size: 0.1rem;
					color: #FFFFFF;
					text-align: center;
					margin-top: 0.07rem;
				}
				.liu-yi-an {
					display: flex;
					align-items: center;
					justify-content: center;
					margin-top: 0.26rem;
					.liu-yi-an1 {
						display: flex;
						align-items: center;
						justify-content: center;
						width: 1.13rem;
						height: 0.34rem;
						background: #FFFFFF;
						box-shadow: 0.01rem 0.02rem 0.03rem 0.01rem rgba(0,0,0,0.3);
						border-radius: 0.08rem 0.08rem 0.08rem 0.08rem;
						img {
							width: 0.07rem;
							height: 0.07rem;
						}
						span {
							font-family: Source Han Sans CN, Source Han Sans CN;
							font-weight: 400;
							font-size: 0.09rem;
							color: #333333;
							margin-left: 0.05rem;
						}
					}
					.liu-yi-an2 {
						display: flex;
						align-items: center;
						justify-content: center;
						width: 1.13rem;
						height: 0.34rem;
						border-radius: 0.08rem 0.08rem 0.08rem 0.08rem;
						border: 0.01rem solid #FFFFFF;
						opacity: 0.5;
						margin-left: 0.19rem;
						img {
							width: 0.07rem;
							height: 0.07rem;
						}
						span {
							font-family: Source Han Sans CN, Source Han Sans CN;
							font-weight: 400;
							font-size: 0.09rem;
							color: #FFFFFF;
							margin-left: 0.05rem;
						}
					}
				}
			}
		}

		img {
			width: 100%;
			height: 100%;
		}
	}
</style>